/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify';
import pinia from '@/stores';
import router from '@/router';
import VueDOMPurifyHTML from 'vue-dompurify-html';

export function registerPlugins(app: any) {
  app.use(vuetify).use(router).use(pinia).use(VueDOMPurifyHTML);
}
